const formatPhone = phone => phone.replace(/\D/g, '').replace(/(\d{2})(\d)(\d{4})(\d{4})$/, '($1) $2 $3-$4')

export default {
  data: function () {
    return {
      actions: false
    }
  },
  props: {
    pet: {
      type: Object,
      require: true
    }
  },
  methods: {
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    },
    maskPhone (phone) {
      return formatPhone(phone)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/pets/index/components/resources/index.js